const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/IdentityProofCard/IdentityProofCard.tsx';
import React from 'react';
import textMap from './translations';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { DashboardCard } from '../DashboardCard';

interface Props {}

export const IdentityProofCard = (props: Props) => {
    const { formatMessage } = useIntl();

    return (
        <DashboardCard iconClass="icons8-info">
            <Typography variant="subtitle1" component="h2" sx={{ color: 'primary.main' }} gutterBottom>
                {formatMessage(textMap.identityProofTitle)}
            </Typography>
            <Typography variant="body1">{formatMessage(textMap.identityProofText)}</Typography>
        </DashboardCard>
    );
};
